import { render } from "./AssetHistory.vue?vue&type=template&id=e13ea890&scoped=true&ts=true"
import script from "./AssetHistory.vue?vue&type=script&lang=ts"
export * from "./AssetHistory.vue?vue&type=script&lang=ts"

import "./AssetHistory.vue?vue&type=style&index=0&id=e13ea890&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e13ea890"]])

export default __exports__